<template>
    <div
        class="custom-radio pa-2"
        :class="{ checked: isChecked }"
        @click="toggleCheck"
    >
        <div class="radio-circle">
            <div v-if="isChecked" class="check-mark"></div>
        </div>
        <span class="label pl-2">{{ label | t }}</span>
    </div>
</template>

<script>
export default {
    props: {
        label: String,
        buttonValue: [String, Number, Boolean],
        value: [String, Number, Boolean]
    },
    computed: {
        isChecked() {
            return this.buttonValue === this.value;
        }
    },
    methods: {
        toggleCheck() {
            this.$emit('input', this.buttonValue);
        }
    }
}
</script>

<style scoped>
.custom-radio {
    display: flex;
    align-items: center;
    cursor: pointer;
    border-radius: 8px;
}
.custom-radio:hover {
    background-color: rgba(240, 240, 240, 1);
}

.radio-circle {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #333;
    margin-right: 8px;
    position: relative;
}

.radio-circle.checked {
    background-color: #fff;
    border-color: red;
}

.check-mark {
    position: absolute;
    top: -1px;
    left: -1px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: transparent;
    border: 6px solid red;
}

.label {
    font-size: 1.2rem;
}
</style>
